module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Celcium-01913d79c2299d07d3b06c991970337e.svg";